import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useApp } from "context/app";
import TasksProvider, { useTasks } from "context/client/tasks";
import queryString from "query-string";

import useResponsive from "libs/helpers/useResponsive";

import DashboardContentLayout from "components/layouts/DashboardContentLayout";
import { TasksTable, TasksTiles } from "page_components/client/tasks";
import {
  StatusExplanation,
  PriorityExplanation,
} from "page_components/shared/tasks/explanations";

const Tasks = () => (
  <TasksProvider>
    <TasksContent />
  </TasksProvider>
);

const TasksContent = () => {
  const { search } = useLocation();
  const query = queryString.parse(search);
  const navigate = useNavigate();
  const { max } = useResponsive();
  const { t } = useTranslation();

  const { websites } = useApp();
  const { init_loading } = useTasks();

  const [explanation, setExplanation] = useState(null);
  const [task_onboarding, setTaskOnboarding] = useState(null);

  const actions = [
    {
      label: t("Add new website"),
      href: "/websites/new",
      event: () =>
        window.gtag("event", "new_website", {
          click_text: t("Add new website"),
          click_url: `/websites/new`,
        }),
    },
    ...(websites?.length > 0
      ? [
          {
            type: "create_client_task",
            onboarding_button: true,
          },
        ]
      : []),
  ];

  useEffect(() => {
    if (query?.onboarding_created) {
      const layoutBody = document.querySelector(
        ".dashboard-layout-content__body",
      );
      if (layoutBody) layoutBody.style.overflow = "hidden";

      setTaskOnboarding(query.onboarding_created);
    }
    // eslint-disable-next-line
  }, [query?.onboarding_created]);

  useEffect(() => {
    if (task_onboarding && max.sm) {
      const layoutBody = document.querySelector(
        ".dashboard-layout-content__body",
      );

      setTaskOnboarding(null);

      if (layoutBody) layoutBody.style.overflow = "";

      navigate("/tasks", { replace: true });
    }
  }, [task_onboarding, navigate, max.sm]);

  const onOnboardingClose = () => {
    const referrer = query?.referrer;

    setTaskOnboarding(null);

    const layoutBody = document.querySelector(
      ".dashboard-layout-content__body",
    );
    if (layoutBody) layoutBody.style.overflow = "";

    window.history.replaceState({}, null, `/tasks`);

    if (!!referrer) navigate(referrer);
  };

  const isSingleWebsite = !!query?.website;

  return (
    <DashboardContentLayout
      header={
        websites?.length > 0
          ? {
              label: t("Tasks"),
              description: t("A list of tasks related to your website."),
            }
          : null
      }
      loading={init_loading}
      actions={actions}
    >
      {!max.lg ? (
        <TasksTable
          task_onboarding={task_onboarding}
          setExplanation={setExplanation}
          onOnboardingClose={onOnboardingClose}
          isSingleWebsite={isSingleWebsite}
        />
      ) : (
        <TasksTiles
          task_onboarding={task_onboarding}
          setExplanation={setExplanation}
          onOnboardingClose={onOnboardingClose}
          isSingleWebsite={isSingleWebsite}
        />
      )}

      <StatusExplanation
        isOpen={explanation === "status"}
        onClose={() => setExplanation(null)}
      />
      <PriorityExplanation
        isOpen={explanation === "priority"}
        onClose={() => setExplanation(null)}
      />
    </DashboardContentLayout>
  );
};

export default Tasks;
